import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // send session_token cookie (Emergent Google Auth)
});

// Attach JWT token if exists (email/password auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public
export const submitContact = (data) => api.post('/contact', data);
export const getStats = () => api.get('/stats');

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const googleSession = (sessionId) => api.post('/auth/google-session', { session_id: sessionId });
export const logoutSession = () => api.post('/auth/logout');
export const getMe = () => api.get('/auth/me');

// Admin
export const listSubmissions = (statusFilter) => {
  const params = statusFilter && statusFilter !== 'all' ? { status_filter: statusFilter } : {};
  return api.get('/admin/submissions', { params });
};
export const getSubmission = (id) => api.get(`/admin/submissions/${id}`);
export const updateSubmission = (id, data) => api.patch(`/admin/submissions/${id}`, data);
export const deleteSubmission = (id) => api.delete(`/admin/submissions/${id}`);
export const getAdminStats = () => api.get('/admin/stats');
export const updatePublicStats = (data) => api.put('/admin/stats', data);

// Donations
export const createDonation = (data) => api.post('/donations', data);
export const startMercadoPago = (data) => api.post('/donations/mercadopago/start', data);
export const confirmMercadoPago = (params) =>
  api.get('/donations/mercadopago/confirm', { params });
export const listDonations = (statusFilter) => {
  const params = statusFilter && statusFilter !== 'all' ? { status_filter: statusFilter } : {};
  return api.get('/admin/donations', { params });
};
export const updateDonation = (id, data) => api.patch(`/admin/donations/${id}`, data);
export const deleteDonation = (id) => api.delete(`/admin/donations/${id}`);

// Gallery
export const getGallery = () => api.get('/gallery');
export const uploadGalleryItem = (data) => api.post('/admin/gallery', data);
export const deleteGalleryItem = (id) => api.delete(`/admin/gallery/${id}`);

// Notifications
export const listNotifications = (onlyUnread = false) =>
  api.get('/admin/notifications', { params: { only_unread: onlyUnread } });
export const markNotificationsRead = (notificationIds = []) =>
  api.post('/admin/notifications/mark-read', { notification_ids: notificationIds });

// Exports & receipts (return blob for download)
const downloadBlob = (path, params = {}) =>
  api.get(path, { params, responseType: 'blob' });

export const exportSubmissionsCSV = (statusFilter) =>
  downloadBlob('/admin/export/submissions.csv', statusFilter && statusFilter !== 'all' ? { status_filter: statusFilter } : {});
export const exportSubmissionsPDF = (statusFilter) =>
  downloadBlob('/admin/export/submissions.pdf', statusFilter && statusFilter !== 'all' ? { status_filter: statusFilter } : {});
export const exportDonationsCSV = (statusFilter) =>
  downloadBlob('/admin/export/donations.csv', statusFilter && statusFilter !== 'all' ? { status_filter: statusFilter } : {});
export const exportDonationsPDF = (statusFilter) =>
  downloadBlob('/admin/export/donations.pdf', statusFilter && statusFilter !== 'all' ? { status_filter: statusFilter } : {});
export const downloadDonationReceipt = (id) =>
  downloadBlob(`/admin/donations/${id}/receipt.pdf`);

export function triggerBrowserDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

export function formatApiError(detail) {
  if (detail == null) return 'Ocurrió un error. Intenta nuevamente.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default api;
